module.exports = __webpack_public_path__ + "static/media/photo74.e0131e47.jpg";